module.exports = __webpack_public_path__ + "static/media/badge.96e24e70.svg";